import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  booleanAttribute,
  computed,
  contentChild,
  input,
  viewChild,
} from '@angular/core';
import { FcTabLabel } from './tab-label.directive';

let nextTabId = 0;

@Component({
  selector: 'fc-tab',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `,
  host: {
    class: 'fc-tab-source',
    hidden: '',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FcTab {
  readonly value = `fc-tab-${nextTabId++}`;

  readonly textLabel = input('', { alias: 'label' });
  readonly disabled = input(false, { transform: booleanAttribute });

  private readonly templateLabel = contentChild(FcTabLabel);
  readonly contentTemplate = viewChild(TemplateRef);

  readonly labelTemplate = computed(
    () => this.templateLabel()?.templateRef ?? null,
  );
}
